// Firebase configuration file
import { initializeApp } from 'firebase/app';
import { getAnalytics } from 'firebase/analytics';

// Firebase configuration
// Sử dụng biến môi trường thay vì hard-coded API keys
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY || "AIzaSyD4zsOzZvfnUaKzUYXdoNst3ZMV24P_Tj0",
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || "mission-manager-315b0.firebaseapp.com",
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID || "mission-manager-315b0",
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET || "mission-manager-315b0.firebasestorage.app",
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || "635410712034",
  appId: process.env.REACT_APP_FIREBASE_APP_ID || "1:635410712034:web:e78d1be65a6e8e174c65bb",
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID || "G-2Z96V0GVSR"
};

// Thiết lập Google Consent Mode mặc định (trước khi người dùng quyết định)
if (typeof window !== 'undefined') {
  window.dataLayer = window.dataLayer || [];
  function gtag() { window.dataLayer.push(arguments); }
  window.gtag = gtag;

  // Default consent for Consent Mode v2
  // Đặt tất cả tùy chọn về 'denied' cho đến khi người dùng đồng ý
  window.gtag('consent', 'default', {
    'ad_storage': 'denied',
    'analytics_storage': 'denied',
    'functionality_storage': 'denied',
    'personalization_storage': 'denied',
    'security_storage': 'granted', // Security cookies are always necessary
    'ad_user_data': 'denied', 
    'ad_personalization': 'denied',
    'wait_for_update': 500 // Chờ 500ms cho người dùng đưa ra quyết định
  });
}

// Kiểm tra kết nối mạng
const isOnline = () => {
  return typeof navigator !== 'undefined' && navigator.onLine;
};

// Khởi tạo Firebase
const app = initializeApp(firebaseConfig);

// Kiểm tra xem người dùng đã cho phép analytics hay chưa
let analytics = null;
if (typeof window !== 'undefined') {
  // Đọc consent từ localStorage nếu có
  const storedConsent = localStorage.getItem('cookieConsent');
  
  // Chỉ khởi tạo analytics nếu online
  if (isOnline()) {
    try {
      if (storedConsent) {
        try {
          const consentData = JSON.parse(storedConsent);
          // Cập nhật consent settings nếu người dùng đã làm việc này trước đó
          window.gtag?.('consent', 'update', {
            'analytics_storage': consentData.analytics ? 'granted' : 'denied',
            'ad_storage': consentData.marketing ? 'granted' : 'denied',
            'personalization_storage': consentData.marketing ? 'granted' : 'denied',
            'functionality_storage': consentData.necessary ? 'granted' : 'denied',
            'ad_user_data': consentData.marketing ? 'granted' : 'denied',
            'ad_personalization': consentData.marketing ? 'granted' : 'denied'
          });
        } catch (e) {
          console.error('Error parsing stored consent:', e);
        }
      }
      
      // Khởi tạo Analytics nếu online
      analytics = getAnalytics(app);
      console.log('Firebase Analytics initialized successfully');
    } catch (e) {
      console.error('Failed to initialize Firebase Analytics:', e);
    }
  } else {
    console.warn('Firebase Analytics not initialized: Device is offline');
  }
  
  // Thêm event listener để cập nhật analytics khi quay lại online
  window.addEventListener('online', () => {
    if (!analytics && isOnline()) {
      try {
        analytics = getAnalytics(app);
        console.log('Firebase Analytics initialized after coming back online');
      } catch (e) {
        console.error('Failed to initialize Firebase Analytics after online:', e);
      }
    }
  });
}

export { app, analytics };
export default app; 